module.exports = __webpack_public_path__ + "img/davidcannon-logo-new.bb7365ae.svg";